import { render } from "./CookieConsentModal.vue?vue&type=template&id=b65386f0"
import script from "./CookieConsentModal.vue?vue&type=script&lang=js"
export * from "./CookieConsentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__